
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'


export default {
components: {
XInput,
XButton,
Group,
Toast
},
data () {
return {
disable: false,
showToast: false,
message: '',
backTime: 60,
disable2: false,
btnSendText: '发送验证码',
data: {
mobile: '',
code: '',
new_password: '',
new_password_confirm: ''
}
}
},
methods: {
doSubmit () {
if (!this.data.mobile) {
this.message = '账号不能为空！'
this.showToast = true
return false
}
if (!this.data.code) {
this.message = '请输入验证码'
this.showToast = true
return false
}
if (!this.data.new_password) {
this.message = '密码不能为空！'
this.showToast = true
return false
}
if (!this.data.new_password_confirm) {
this.message = '密码不能为空！'
this.showToast = true
return false
}
this.$store.dispatch('forgetSellpwd', this.data).then((res) => {
if (res.status > 0) {
this.$vux.toast.text('修改成功', 'top')
this.$router.push({path: '/login/index'})
} else {
this.message = res.msg
this.showToast = true
}
})
},

doSend () {
if (!this.data.mobile) {
this.message = '请输入手机号'
this.showToast = true
return false
}
this.backTime = 60
this.$store.dispatch('sendCode', this.data).then((res) => {
if (res.status < 0) {
this.message = res.msg
this.showToast = true
return false
} else {
this.setTime()
}
})
},

setTime () {
const that = this
if (this.backTime === 0) {
this.btnSendText = '发送验证码'
this.disable2 = false
} else {
this.disable2 = true
this.btnSendText = this.backTime + ' 秒后再次获取'
this.backTime--
setTimeout(function () {
that.setTime()
}, 1000)
}
},
returnLogin () {
this.$router.push({path: '/login/index'})
}
}
}



// WEBPACK FOOTER //
// ./src/components/login/Reset.vue